import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface ConsultancysProps {}

const Consultancys = ({}: ConsultancysProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Consultancy")}
          subtitle={t("Services")}
          thirdTitle={t("Consultancy")}
        />

        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/Consultancy.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "I am going to start my own business! I am going to redesign my website! I need my website to bring me more money! Yes, easy to say but hard to do. Not for Onyxcom, it’s EASY when you know how! We want to learn first what you’re looking for and what your business, company, or individual website is aiming to communicate. Our personalized approach ensures that every aspect of your website aligns with your goals, attracting and converting your target audience effectively. Let us turn your digital aspirations into a thriving reality. Empower your online presence with Onyxcom today."
              )}
            </p>
          </div>
        </section>

        {/*  Our core service is developing **************/}
        <section className="my-[100px] px-[20px] lg:px-[144px] 2xl:px-[180px] w-full flex flex-col gap-10">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t(
              "Our advice will bring you success through consultancy regarding"
            )}
          </p>
          {/* grid section  *****************/}
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="font-[700] text-[20px]">
                {t("Idea and business creation")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Starting from scratch or looking to innovate within your industry, we provide expert guidance to shape your ideas into viable business ventures."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Your current website audit.")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Gain valuable insights and optimize your online presence with our comprehensive Current Website Audit service."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Web traffic optimization.")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We specialize in analyzing and enhancing your online presence to drive targeted traffic, and achieve your business objectives."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("The winning strategy steps")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Navigate the complexities of digital transformation with our Winning Strategy Steps consultancy services."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Web traffic analysis")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Our comprehensive analysis helps you make informed decisions to enhance digital marketing strategies and achieve measurable results."
                )}
              </p>
            </div>

            <div>
              <p className="font-[700] text-[20px]">
                {t("Technology analysis")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Stay ahead of the curve with our Technology Analysis consultancy services. We specialize in assessing your current technology landscape."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default Consultancys;
